import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  useLocation,
  useHistory,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import "./App.css";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import HomePage from "./pages/common/HomePage";
import AboutUsPage from "./pages/common/AboutUsPage";
import NotFoundPage from "./pages/common/NotFoundPage";
import ContactUsPage from "./pages/common/ContactUsPage";
import CatagoriesPage from "./pages/common/CatagoriesPage";
import PrivacyPolicyPage from "./pages/common/PrivacyPolicyPage.jsx";
import AuthPage from "./pages/common/AuthPage.jsx";
import DetailPage from "./pages/common/DetailPage.jsx";
import ShopingCardPage from './pages/common/ShopingCardPage';
import PaymentPage from "./pages/common/PaymentPage.jsx";
import LoginPage from "./pages/admin/auth/LoginPage.jsx";
import DrawerComponent from "./components/Drawer/DrawerComponent.jsx";
import CatagoriesDetail from "./pages/common/CategoriesDetailPage.jsx";
import CatagoriesDetailPage from "./pages/common/CategoriesDetailPage.jsx";
import OrderStatus from "./pages/common/OrderStatus.jsx";
import OrderList from "./pages/common/OrderList.jsx";
import { CartProvider } from "./context/CartContext.js";
import PromoCodePage from "./pages/admin/promo/PromoCodePage.jsx";
import ChatPage from "./pages/common/ChatPage.jsx";
import { _DecryptService } from "./service/EncryptDecryptService";
import _JWTDecodeService from "./service/JWTDecodeService";
import Footer from "./components/Footer/Footer.jsx";

const Layout = ({ children }) => {
  const location = useLocation();
  const history = useHistory();
  const isLiveChatEnabled = process.env.REACT_APP_ENABLE_LIVE_CHAT === "true";
  const shouldShowChatFab =
    isLiveChatEnabled && !location.pathname.includes("/chat");
  const isAdminRoute = location.pathname.startsWith("/admin");

  const handleChatNavigation = () => {
    const token = sessionStorage.getItem("token");
    let userEmail = "";
    if (token) {
      try {
        const decryptedToken = _DecryptService(token);
        const decoded = _JWTDecodeService(decryptedToken);
        userEmail = decoded?.Email ? _DecryptService(decoded.Email) : "";
      } catch (error) {
        console.error("Unable to decode session token for chat redirect:", error);
      }
    }
    if (!token) {
      history.push("/auth?type=logIn");
      return;
    }
    if (userEmail && userEmail.toLowerCase() === "admin@gmail.com") {
      history.push("/admin/chat");
    } else {
      history.push("/chat");
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <div style={{ flex: "1 0 auto" }}>{children}</div>
      {!isAdminRoute && <Footer />}
      {shouldShowChatFab && (
        <button
          type="button"
          className="chat-fab"
          onClick={handleChatNavigation}
        >
          <SupportAgentIcon className="chat-fab__icon" />
          Live Chat
        </button>
      )}
    </div>
  );
};

export default function App() {
  return (
    <CartProvider>
      <Router>
        <Layout>
          <Switch>
            <Route exact path="/" component={HomePage} />
            <Route exact path="/aboutUs" component={AboutUsPage} />
            <Route exact path="/contactUs" component={ContactUsPage} />
            <Route exact path="/categories" component={CatagoriesPage} />
            <Route exact path="/privacypolicy" component={PrivacyPolicyPage} />
            <Route
              exact
              path="/categoriesDetail"
              component={CatagoriesDetailPage}
            />
            <Route exact path="/auth">
              <AuthPage />
            </Route>
            <Route exact path="/detail" component={DetailPage} />
            <Route exact path="/detail/:id" component={DetailPage} />
            <Route exact path="/payment" component={PaymentPage} />
            <Route exact path="/card" component={ShopingCardPage} />
            <Route exact path="/admin/login" component={LoginPage} />
            <Route
              exact
              path="/admin/manage"
              render={() => {
                const token = sessionStorage.getItem("token");
                if (!token) {
                  return <Redirect to="/admin/login" />;
                }
                let role = null;
                let businessName = null;
                try {
                  const decryptedToken = _DecryptService(token);
                  const decoded = _JWTDecodeService(decryptedToken);
                  role = decoded?.UserRole
                    ? _DecryptService(decoded.UserRole)
                    : null;
                  businessName = decoded?.BusinessName
                    ? _DecryptService(decoded.BusinessName)
                    : null;
                } catch (error) {
                  console.error(
                    "Unable to decode session token for admin route:",
                    error
                  );
                  return <Redirect to="/admin/login" />;
                }
                const expectedBusinessName = process.env.REACT_APP_BUSINESS_NAME;
                const normalizeName = (value) =>
                  (value || "").toLowerCase().replace(/\s+/g, "");
                if (
                  normalizeName(expectedBusinessName) &&
                  normalizeName(businessName) &&
                  normalizeName(businessName) !==
                    normalizeName(expectedBusinessName)
                ) {
                  sessionStorage.removeItem("token");
                  sessionStorage.removeItem("cartItemCount");
                  return <Redirect to="/admin/login" />;
                }
                if (role === "Admin" || role === "Staff") {
                  return <DrawerComponent />;
                }
                return <Redirect to="/" />;
              }}
            />
            <Route exact path="/orderList" component={OrderList} />
            <Route exact path="/orderStatus" component={OrderStatus} />
            <Route exact path="/promoCode" component={PromoCodePage} />
            <Route
              exact
              path="/chat"
              render={(routeProps) => (
                <ChatPage {...routeProps} roleFilter="admin" />
              )}
            />
            <Route
              exact
              path="/admin/chat"
              render={(routeProps) => (
                <ChatPage
                  {...routeProps}
                  roleFilter="default"
                  forcedCometChatUid="cometchat-uid-1"
                />
              )}
            />
            <Route component={NotFoundPage} />
          </Switch>
        </Layout>
        <ToastContainer />
      </Router>
    </CartProvider>
  );
}
